import { Suspense, lazy, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import DefaultPageSkeletonBuilder from '@components/skeletons/default-page-skeleton/DefaultPageSkeletonBuilder';
import PageSuspense from '@components/skeletons/page-suspense/PageSuspense';
import MainLayout from '@layouts/main/MainLayout';
import { DefinedRoutes } from '@routes/definedRoutes';

import withClearCache from './withClearCache';

const PaymentFeedback           = lazy(() => import('pages/payment/Payment'));

const App = () => {
    // THIS IS THE OPTION THAT YOU CAN OPT, BUT DIFFERENT BROWSERS WILL
    // HAVE THEIR DIFFERENT MESSAGES FOR PROMPTING BEFORE RELOAD. ELSE
    // IF YOU ARE USING BROWSER-ROUTER IN YOUR CODE. GIVE A SHOT FOR
    // THIS. https://v5.reactrouter.com/web/api/BrowserRouter (forceRefresh prop)

    useEffect(() => {
        window.addEventListener('beforeunload', () => true);

        return () => window.removeEventListener('beforeunload',  () => false);
    }, []);

    return (
        <Suspense fallback={<PageSuspense SkeletonBuilder={DefaultPageSkeletonBuilder}/>}>
            <Routes>
                <Route index path="*" element={<MainLayout />}/>

                {/* payment feedback page (error or success feedback)*/}
                <Route
                    path={DefinedRoutes.paymentFeedback.name}
                    element={
                        <Suspense fallback={<></>}>
                            <PaymentFeedback />
                        </Suspense>
                    }
                />
            </Routes>
        </Suspense>
    );
};

export default withClearCache(App);
